import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { db, storage } from "./firebase";
import {
  doc,
  getDoc,
  updateDoc,
} from "firebase/firestore";
import {
  ref,
  uploadBytesResumable,
  getDownloadURL,
  deleteObject,
} from "firebase/storage";

const fixedTags = ["3D", "VFX", "Animation", "Motion Graphics", "Graphics Design"];

export default function EditProject() {
  const { projectId } = useParams();
  const navigate = useNavigate();

  const [title, setTitle] = useState("");
  const [description, setDescription] = useState("");
  const [tag, setTag] = useState("3D");
  const [media, setMedia] = useState([]); // existing media
  const [files, setFiles] = useState([]); // new files
  const [uploading, setUploading] = useState(false);
  const [progress, setProgress] = useState(0);

  useEffect(() => {
    const fetchProject = async () => {
      try {
        const snap = await getDoc(doc(db, "projects", projectId));
        if (snap.exists()) {
          const data = snap.data();
          setTitle(data.title || "");
          setDescription(data.description || "");
          setTag(data.tag || "3D");
          setMedia(data.media || []);
        }
      } catch (err) {
        console.error("Error loading project", err);
      }
    };
    fetchProject();
  }, [projectId]);

  const removeExisting = async (index) => {
    const removed = media[index];
    setMedia(media.filter((_, i) => i !== index));

    try {
    await deleteObject(ref(storage, removed.url));
    } catch (err) {
      console.error("Error deleting file", err);
    }
  };

  const handleUpdate = async () => {
    if (!title || !description) {
      alert("Please fill out all fields.");
      return;
    }

    setUploading(true);
    const newMedia = [];

    for (const file of files) {
      const fileType = file.type.startsWith("video") ? "video" : "image";
      const fileRef = ref(storage, `projects/${projectId}/${file.name}`);
      const uploadTask = uploadBytesResumable(fileRef, file);

      await new Promise((resolve, reject) => {
        uploadTask.on(
          "state_changed",
          (snapshot) => {
            const prog = Math.round(
              (snapshot.bytesTransferred / snapshot.totalBytes) * 100
            );
            setProgress(prog);
          },
          reject,
          async () => {
            const url = await getDownloadURL(uploadTask.snapshot.ref);
            newMedia.push({ type: fileType, url });
            resolve();
          }
        );
      });
    }

    const updatedMedia = [...media, ...newMedia];
    const coverImage =
      updatedMedia.find((m) => m.type === "image")?.url || updatedMedia[0]?.url || "";

    await updateDoc(doc(db, "projects", projectId), {
      title,
      description,
      tag,
      media: updatedMedia,
      coverImage,
    });

    setUploading(false);
    navigate("/dashboard");
  };

  return (
    <section className="contact section" id="edit">
      <div className="container">
        <div className="row">
          <div className="section-title padd-15">
            <h2>Edit Project</h2>
          </div>
        </div>
        <div className="row">
          <div className="contact-form padd-15" style={{ width: "100%" }}>
            <div className="row">
              <div className="form-item col-12 padd-15">
                <div className="form-group">
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Project Title"
                    value={title}
                    onChange={(e) => setTitle(e.target.value)}
                  />
                </div>
              </div>
              <div className="form-item col-12 padd-15">
                <div className="form-group">
                  <textarea
                    className="form-control"
                    rows="4"
                    placeholder="Project Description"
                    value={description}
                    onChange={(e) => setDescription(e.target.value)}
                  />
                </div>
              </div>
              <div className="form-item col-12 padd-15">
                <div className="form-group">
                  <select
                    className="form-control"
                    value={tag}
                    onChange={(e) => setTag(e.target.value)}
                  >
                    {fixedTags.map((t) => (
                      <option key={t} value={t}>
                        {t}
                      </option>
                    ))}
                  </select>
                </div>
              </div>
              <div className="form-item col-12 padd-15">
                <input
                  type="file"
                  multiple
                  accept="image/*,video/*"
                  onChange={(e) => setFiles([...e.target.files])}
                />
              </div>
              {media.length > 0 && (
                <ul className="edit-file-list col-12 padd-15">
                  {media.map((m, idx) => (
                    <li key={idx} className="edit-file-item">
                      <span>{m.url.split("/").pop().split("?")[0]}</span>
                      <button type="button" onClick={() => removeExisting(idx)}>
                        &times;
                      </button>
                    </li>
                  ))}
                </ul>
              )}
              {files.length > 0 && (
                <ul className="edit-file-list col-12 padd-15">
                  {files.map((f, idx) => (
                    <li key={idx} className="edit-file-item">
                      <span>{f.name}</span>
                    </li>
                  ))}
                </ul>
              )}
              <div className="form-item col-12 padd-15">
                <button
                  type="button"
                  className="btn"
                  onClick={handleUpdate}
                  disabled={uploading}
                >
                  {uploading ? `Updating... (${progress}%)` : "Update"}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}